import styled from "styled-components";

export const Stars = styled.div`
  width: auto;
  height: auto;
  white-space: nowrap;
  display: flex;
  justify-content: center;
`;
